// extracted by extract-css-chunks-webpack-plugin
module.exports = {"errorBoxWrapper":"pS-YSw","messageBoxWrapper":"_3iXY6_","spinnerWrapper":"_2GeEVd","markdown":"_2fVaxc"};